/* src/app/modules/file/files-dialog-repair.component.css */
.repair-hint {
  color: #666;
  font-size: 13px;
  margin-bottom: 12px;
}
.repair-error {
  color: #c62828;
  margin: 8px 0;
}
.loading-container {
  display: flex;
  justify-content: center;
  padding: 16px;
}
.repair-result h4 {
  margin-bottom: 4px;
  margin-top: 12px;
}
.repair-result ul {
  max-height: 160px;
  overflow-y: auto;
  padding-left: 18px;
  margin: 0;
}
/*# sourceMappingURL=files-dialog-repair.component.css.map */
